import React, {Component} from 'react';
import DragzoneRow from '../DragzoneRow';
import {Types} from '../../Services/Types';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import {resetStorage } from '../../Services/Drop/action';
import FontAwesome from 'react-fontawesome' ;
import './style.scss';

class Dragzone extends Component {

    constructor(props, context) {
		super(props, context);

        this.state = {
            style: {}
        }
    }

    render = () => {
        const {dragElements} = this.props;
        return (
            
            <div className="settings">
            {
                dragElements.map(function(value, index){
                    return <DragzoneRow key={index} index={index} type={value.type} image={value.image} productName={value.name} height={value.height} width={value.width} />
                })
                
            }
            <p className="has-text-centered"><i>Mått ( B ) avser c/c mått mellan stolparna.</i></p>
            <div className="zoombtn has-text-centered">
                <a className="button" href="#" onClick={(e) => this.props.zoomin(e)}>
                <span className="icon"><FontAwesome name='search-plus' size='2x' /></span><span>Större rityta</span>
                
                </a> 
                <a href="#" className="button" onClick={(e) => this.props.zoomout(e)}>
                <span className="icon"><FontAwesome name='search-minus' size='2x' /></span><span>Mindre rityta</span>
                </a>
            </div>
            <hr />
            <button className="button resetbtn" onClick={() => this.props.resetStorage()}>Börja om</button>
            </div>
            
                
                    
                
        )
    }
}
const mapStateToProps = (state) => {
    return {
    };
};
const mapDispatchToProps = (dispatch) => {
  return {
      resetStorage: bindActionCreators(resetStorage, dispatch)
  };
}; 

export default connect(mapStateToProps, mapDispatchToProps)(Dragzone);


// WEBPACK FOOTER //
// ./src/Components/Dragzone/index.js